var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('button',{staticClass:"button",on:{"click":_vm.goToBrokers}},[_vm._v("Start New Report")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }